// Check if the browser supports Scroll-Driven Animations
const supportsScrollDriven = CSS.supports("animation-timeline", "scroll()");

if (!supportsScrollDriven || !("scrollTimeline" in window || CSS.supports("animation-timeline", "--test"))) {
    document.addEventListener("DOMContentLoaded", () => {
        const container = document.querySelector(".scroll-container");
        const thumb = document.querySelector(".custom-thumb");
        const track = document.querySelector(".custom-track");

        if (!container || !thumb || !track) {
            return;
        }

        function updateThumbPosition() {
            // Calculate the scroll percentage
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight - container.clientHeight;
            const scrollPercentage = scrollTop / scrollHeight;

            // Calculate the available track height
            // Subtract thumb height (14px) so it doesn't overflow the track
            const trackHeight = track.clientHeight - 14;
            const thumbPosition = scrollPercentage * trackHeight;

            // Apply the new position
            thumb.style.top = `${thumbPosition}px`;
        }

        // Listen for scroll events
        container.addEventListener("scroll", updateThumbPosition);

        // Initial call in case the browser pre-loads a scroll position
        updateThumbPosition();
    });
}
